import { useDisclosure } from "@chakra-ui/react";
import { FaInfoCircle, FaSearch } from "react-icons/fa";
import Info from "./modal/Info";
import Search from "./modal/Search";

const Controls = () => {
  const {
    isOpen: isOpenSearch,
    onOpen: onOpenSearch,
    onClose: onCloseSearch,
  } = useDisclosure();
  const {
    isOpen: isOpenInfo,
    onOpen: onOpenInfo,
    onClose: onCloseInfo,
  } = useDisclosure();

  return (
    <>
      <Info isOpen={isOpenInfo} onClose={onCloseInfo} />
      <Search isOpen={isOpenSearch} onClose={onCloseSearch} />
      <div className="flex items-center justify-center gap-10 text-2xl text-rss-primary-color">
        <FaSearch onClick={onOpenSearch} className="cursor-pointer" />
        <FaInfoCircle onClick={onOpenInfo} className="cursor-pointer" />
      </div>
    </>
  );
};

export default Controls;
